import React from "react";

import Customer from "../details/Customer";
import { DetailModal } from "../ui";

const CustomerModal = ({ open, selectedCustomer, handleClose, handleClickOpen }) => {
    if (!selectedCustomer) return null;

    return (
        <DetailModal
            open={open}
            onClose={handleClose}
            size="xl"
            title="Customer Details"
            fullPagePath={`/customers/${selectedCustomer._id}`}
        >
            <Customer customer={selectedCustomer} handleClickOpen={handleClickOpen} />
        </DetailModal>
    );
};

export default CustomerModal;
